import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as insight360Actions from '../../../actions/insight360Actions';
import * as definitionActions from '../../../actions/definitionActions';
import editIconDefault from '../../../images/insight360/edit-icon_default.png';
import infoIconWhite from '../../../images/insight360/info-icon_white.png';
import {
  LENGTH_OF_SEGMENT_LABEL,
  MAX_SEGMENT_LABEL_TEXT_COUNT,
  INSIGHT_360_CREATOR_SEGMENT_SIZE_INFO,
  UPDATE_FOR_SEGMENT_LABEL,
  SAMPLE_LABEL,
  WEIGHTED_LABEL,
  SEGMENT_SIZE_LABEL,
} from '../../../constants';
import { numberWithCommas, findObjectIndexInArray } from '../../../util/CommonUtils';
import {
  SEGMENT_LABEL_TEXT_EXCEED_WARNING,
  DUPLICATE_SEGMENT_WARNING,
  WEIGHTED_INFO_MSG,
  SAMPLE_INFO_MSG,
} from '../../../messages/messages';
import InlineEdit from '../../common/InlineEdit/InlineEdit';

class PersonaCreatorSegmentsHeaderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      segmentTitle: props.headerSegmentDetail.title,
    };
  }

  _personaSegmentLabelValidate = (value, callback) => {
    const multiClusterSegments = _.clone(
      this.props.multiClusterSegments.segments,
    );
    if (value.length <= MAX_SEGMENT_LABEL_TEXT_COUNT) {
      new Promise(resolve => {
        const index = findObjectIndexInArray(
          multiClusterSegments,
          'title',
          value,
        );
        resolve(index);
      }).then(findIndex => {
        if (findIndex === -1) {
          callback(true);
        } else {
          callback(false, DUPLICATE_SEGMENT_WARNING);
        }
      });
    } else {
      callback(
        false,
        `${SEGMENT_LABEL_TEXT_EXCEED_WARNING +
          MAX_SEGMENT_LABEL_TEXT_COUNT
          } Characters`,
      );
    }
  };

  _personaSegmentLabelUpdate = (value, callback) => {
    const segmentObj = _.clone(this.props.headerSegmentDetail);
    segmentObj.title = value;
    this.props.saveUpdatedSegmentData(segmentObj, callback);
  };

  render() {
    return (
      <div>
        {this.props.headerSegmentDetail !== undefined && (
          <div className="creator-segments-info-div">
            <div className="div-overflow">
              <div className="demographic-float segments-info-width">
                <div id="SegmentheaderFlag" className="creator-segments-info">
                  <InlineEdit
                    textVal={this.props.headerSegmentDetail.title}
                    updateFn={this._personaSegmentLabelUpdate}
                    validateFn={this._personaSegmentLabelValidate}
                    editBlockWidth="100%"
                    icon={editIconDefault}
                  />
                </div>
              </div>
            </div>

            <div className="row fullwidth" id="pdfSegmentheaderFlag">
              <span className="pdf-creator-segments-info">
                {this.props.headerSegmentDetail.title.substring(
                  0,
                  LENGTH_OF_SEGMENT_LABEL,
                )}
              </span>
            </div>
            <div className="row fullwidth pdfSegmentInfoSect">
              <div className="columns small-4 data-comparision-tb-section pdfheaderSegmentLabel">
                <div className="comparision-info-label">
                  {SEGMENT_SIZE_LABEL}
                  <img
                    alt="info_icon"
                    className="i360_header_icons_img size-sm"
                    src={infoIconWhite}
                    title={INSIGHT_360_CREATOR_SEGMENT_SIZE_INFO}
                  />
                </div>
                <div className="pdf-data-comparision-tb-section">
                  {Math.round(this.props.headerSegmentDetail.pct * 1000) / 10}%
                </div>
              </div>
              <div className="columns small-5 data-comparision-tb-section pdfheaderSegmentLabel">
                <div className="comparision-info-label">
                  {WEIGHTED_LABEL}
                  <img
                    alt="info_icon"
                    className="i360_header_icons_img size-sm"
                    src={infoIconWhite}
                    title={WEIGHTED_INFO_MSG}
                  />
                </div>
                <div className="pdf-data-comparision-tb-section">
                  {numberWithCommas(
                    Math.round(this.props.headerSegmentDetail.weighted),
                  )}
                </div>
              </div>
              <div className="columns small-3 data-comparision-tb-section pdfheaderSegmentLabel">
                <div className="comparision-info-label">
                  {SAMPLE_LABEL}
                  <img
                    alt="info_icon"
                    className="i360_header_icons_img size-sm"
                    src={infoIconWhite}
                    title={SAMPLE_INFO_MSG}
                  />
                </div>
                <div className="pdf-data-comparision-tb-section">
                  {numberWithCommas(
                    Math.round(this.props.headerSegmentDetail.sample),
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

PersonaCreatorSegmentsHeaderInfo.propTypes = {
  headerSegmentDetail: PropTypes.shape({
    sample: PropTypes.number,
    weighted: PropTypes.number,
    pct: PropTypes.number,
    title: PropTypes.string,
  }),
  multiClusterSegments: PropTypes.shape({
    segments: PropTypes.arrayOf(),
  }),
  saveUpdatedSegmentData: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    multiClusterSegments: state.insight360.personaCreator.multiClusterSegments,
    personaCreator: state.insight360.personaCreator.segments,
    token: state.login.loginResponse.data.token,
    uid: state.login.loginResponse.data.uid,
    activeAccountId: state.account.activeAccountId,
    smartSearchStudy: state.study.insight360study,
    personaCreatorHeader: state.insight360.personaCreator.header,
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const refreshDefinationdata = () => {
    dispatch(
      definitionActions.getDefinitionTreeLoad(
        stateProps.token,
        stateProps.smartSearchStudy.ss === 'SIMMONS' ? 1 : 2,
        stateProps.activeAccountId,
        stateProps.smartSearchStudy.pn,
      ),
    );
  };

  const saveUpdatedSegmentData = (updatedSegmentData, callbackFn) => {
    const segments = [];
    segments.push(updatedSegmentData);
    const data = {
      defId: stateProps.personaCreator.defId,
      defName: stateProps.personaCreatorHeader.label,
      segments,
      productNo: stateProps.smartSearchStudy.pn,
    };
    dispatch(
      insight360Actions.saveUpdatedData(
        stateProps.token,
        stateProps.uid,
        stateProps.activeAccountId,
        data,
        UPDATE_FOR_SEGMENT_LABEL,
        callbackFn,
        refreshDefinationdata,
      ),
    );
  };

  return { ...stateProps, ...ownProps, saveUpdatedSegmentData, };
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(PersonaCreatorSegmentsHeaderInfo);
